// common

export const LOADING = 'LOADING'
export const STOP_LOADING = 'STOP_LOADING'

// login
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILED = 'REGISTER_FAILED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILED = 'LOGOUT_FAILED'
export const CLEAR_LOGIN_STATE = 'CLEAR_LOGIN_STATE'

// shopping

export const FETCH_LIST_SUCCESS = 'FETCH_LIST_SUCCESS'
export const FETCH_LIST_FAILED = 'FETCH_LIST_FAILED'
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS'
export const FETCH_ORDERS_FAILED = 'FETCH_ORDERS_FAILED'
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS'
export const FETCH_CUSTOMERS_FAILED = 'FETCH_CUSTOMERS_FAILED'
export const EDIT_CUSTOMER_SUCCESS = 'EDIT_CUSTOMER_SUCCESS'
export const EDIT_CUSTOMER_FAILED = 'EDIT_CUSTOMER_FAILED'
export const REMOVE_CUSTOMER_SUCCESS = 'REMOVE_CUSTOMER_SUCCESS'
export const REMOVE_CUSTOMER_FAILED = 'REMOVE_CUSTOMER_FAILED'
export const CLEAR_SHOPPING_STATE = 'CLEAR_SHOPPING_STATE'
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS'
export const ADD_ORDER_FAILED = 'ADD_ORDER_FAILED'
export const REMOVE_ORDER_SUCCESS = 'REMOVE_ORDER_SUCCESS'
export const REMOVE_ORDER_FAILED = 'REMOVE_ORDER_FAILED'
export const EDIT_ORDER_SUCCESS = 'EDIT_ORDER_SUCCESS'
export const EDIT_ORDER_FAILED = 'EDIT_ORDER_FAILED'
export const ADD_PART_SUCCESS = 'ADD_PART_SUCCESS'
export const ADD_PART_FAILED = 'ADD_PART_FAILED'
